export  const crypto_ticks = () => {
    return [
        "btcusdt@miniTicker",
        "ethusdt@miniTicker",
        "bnbusdt@miniTicker",
        "xrpusdt@miniTicker",
        "usdtusdt@miniTicker",
        "adausdt@miniTicker",
        "dogeusdt@miniTicker",
        "dotusdt@miniTicker",
        "uniusdt@miniTicker",
        "ltcusdt@miniTicker",
        "bchusdt@miniTicker",
        "linkusdt@miniTicker",
        "vetusdt@miniTicker",
        "usdcusdt@miniTicker",
        "xlmusdt@miniTicker",
        "thetausdt@miniTicker",
        "filusdt@miniTicker",
        "solusdt@miniTicker",
        "trxusdt@miniTicker",
        "wbtcusdt@miniTicker",
        "busdusdt@miniTicker",
        "xmrusdt@miniTicker",
        "neousdt@miniTicker",
        "klayusdt@miniTicker",
        "eosusdt@miniTicker",
        "miotausdt@miniTicker",
        "bsvusdt@miniTicker",
        "lunausdt@miniTicker",
        "bttusdt@miniTicker",
        "crousdt@miniTicker",
        "okbusdt@miniTicker",
        "atomusdt@miniTicker",
        "aaveusdt@miniTicker",
        "fttusdt@miniTicker",
        "cusdcusdt@miniTicker",
        "cethusdt@miniTicker",
        "etcusdt@miniTicker",
        "cakeusdt@miniTicker",
        "xtzusdt@miniTicker",
        "mkrusdt@miniTicker",
        "htusdt@miniTicker",
        "algousdt@miniTicker",
        "daiusdt@miniTicker",
        "AVAXusdt@miniTicker",
        "xemusdt@miniTicker",
        "egldusdt@miniTicker",
        "ksmusdt@miniTicker",
        "runeusdt@miniTicker",
        "cdaiusdt@miniTicker",
        "dashusdt@miniTicker",
        "chzusdt@miniTicker",
        "compusdt@miniTicker",
        "hotusdt@miniTicker",
        "dcrusdt@miniTicker",
        "zecusdt@miniTicker",
        "snxusdt@miniTicker",
        "celusdt@miniTicker",
        "stxusdt@miniTicker",
        "enjusdt@miniTicker",
        "dgbusdt@miniTicker",
        "hbarusdt@miniTicker",
        "zilusdt@miniTicker",
        "maticusdt@miniTicker",
        "leousdt@miniTicker",
        "nexousdt@miniTicker",
        "scusdt@miniTicker",
        "sushiusdt@miniTicker",
        "grtusdt@miniTicker",
        "ampusdt@miniTicker",
        "ustusdt@miniTicker",
        "feiusdt@miniTicker",
        "batusdt@miniTicker",
        "manausdt@miniTicker",
        "nearusdt@miniTicker",
        "yfiusdt@miniTicker",
        "qtumusdt@miniTicker",
        "umausdt@miniTicker",
        "ontusdt@miniTicker",
        "hbtcusdt@miniTicker",
        "rvnusdt@miniTicker",
        "btgusdt@miniTicker",
        "wavesusdt@miniTicker",
        "arrrusdt@miniTicker",
        "wrxusdt@miniTicker",
        "zrxusdt@miniTicker",
        "rsrusdt@miniTicker",
        "icxusdt@miniTicker",
        "flowusdt@miniTicker",
        "zenusdt@miniTicker",
        "lusdusdt@miniTicker",
        "bntusdt@miniTicker",
        "iostusdt@miniTicker",
        "nanousdt@miniTicker",
        "omiusdt@miniTicker",
        "xdcusdt@miniTicker",
        "chsbusdt@miniTicker",
        "oneusdt@miniTicker",
        "omgusdt@miniTicker",
        "paxusdt@miniTicker",
        "ankrusdt@miniTicker",
        "kcsusdt@miniTicker",
        "hntusdt@miniTicker",
        "ftmusdt@miniTicker",
        "xvgusdt@miniTicker",
        "arusdt@miniTicker",
        "btmxusdt@miniTicker",
        "winusdt@miniTicker",
        "npxsusdt@miniTicker",
        "husdusdt@miniTicker",
        "crvusdt@miniTicker",
        "pundixusdt@miniTicker",
        "1inchusdt@miniTicker",
        "dentusdt@miniTicker",
        "xsushiusdt@miniTicker",
        "renusdt@miniTicker",
        "xvsusdt@miniTicker",
        "vgxusdt@miniTicker",
        "lskusdt@miniTicker",
        "lrcusdt@miniTicker",
        "vthousdt@miniTicker",
        "lptusdt@miniTicker",
        "SNTusdt@miniTicker",
        "renbtcusdt@miniTicker",
        "nxmusdt@miniTicker",
        "balusdt@miniTicker",
        "bchausdt@miniTicker",
        "stethusdt@miniTicker",
        "botusdt@miniTicker",
        "celousdt@miniTicker",
        "gtusdt@miniTicker",
        "oxyusdt@miniTicker",
        "zksusdt@miniTicker",
        "oceanusdt@miniTicker",
        "cusdtusdt@miniTicker",
        "knclusdt@miniTicker",
        "ckbusdt@miniTicker",
        "tribeusdt@miniTicker",
        "ewtusdt@miniTicker",
        "qntusdt@miniTicker",
        "mirusdt@miniTicker",
        "maidusdt@miniTicker",
        "btcstusdt@miniTicker",
        "axsusdt@miniTicker",
        "bandusdt@miniTicker",
        "nknusdt@miniTicker",
        "ognusdt@miniTicker",
        "glmusdt@miniTicker",
        "tonusdt@miniTicker",
        "cuniusdt@miniTicker",
        "bcdusdt@miniTicker",
        "stmxusdt@miniTicker",
        "reefusdt@miniTicker",
        "amplusdt@miniTicker",
        "etnusdt@miniTicker",
        "dodousdt@miniTicker",
        "nmrusdt@miniTicker",
        "mdxusdt@miniTicker",
        "medusdt@miniTicker",
        "telusdt@miniTicker",
        "btmusdt@miniTicker",
        "rfoxusdt@miniTicker",
        "alphausdt@miniTicker",
        "hbcusdt@miniTicker",
        "ardrusdt@miniTicker",
        "sklusdt@miniTicker",
        "cvcusdt@miniTicker",
        "funusdt@miniTicker",
        "orbsusdt@miniTicker",
        "sandusdt@miniTicker",
        "tlmusdt@miniTicker",
        "steemusdt@miniTicker",
        "ornusdt@miniTicker",
        "antusdt@miniTicker",
        "waxpusdt@miniTicker",
        "kmdusdt@miniTicker",
        "fetusdt@miniTicker",
        "rayusdt@miniTicker",
        "sxpusdt@miniTicker",
        "agiusdt@miniTicker",
        "noiausdt@miniTicker",
        "kinusdt@miniTicker",
        "tusdusdt@miniTicker",
        "woousdt@miniTicker",
        "srmusdt@miniTicker",
        "sethusdt@miniTicker",
        "ubtusdt@miniTicker",
        "rddusdt@miniTicker",
        "vlxusdt@miniTicker",
        "alcxusdt@miniTicker",
        "btsusdt@miniTicker",
        "polyusdt@miniTicker",
        "aktusdt@miniTicker",
        "celrusdt@miniTicker",
        "arkusdt@miniTicker",
        "metausdt@miniTicker",
        "zmtusdt@miniTicker",
        "kobeusdt@miniTicker",
        "rplusdt@miniTicker",
        "kavausdt@miniTicker",
        "ancusdt@miniTicker",
        "uosusdt@miniTicker",
        "xhvusdt@miniTicker",
        "gnousdt@miniTicker",
        "wanusdt@miniTicker",
        "mtlusdt@miniTicker",
        "paidusdt@miniTicker",
        "audiousdt@miniTicker",
        "iotxusdt@miniTicker",
        "storjusdt@miniTicker",
        "mathusdt@miniTicker",
        "badgerusdt@miniTicker",
        "uqcusdt@miniTicker",
        "swapusdt@miniTicker",
        "klvusdt@miniTicker",
        "avausdt@miniTicker",
        "iqusdt@miniTicker",
        "usdnusdt@miniTicker",
        "injusdt@miniTicker",
        "htrusdt@miniTicker",
        "kaiusdt@miniTicker",
        "sfpusdt@miniTicker",
        "cruusdt@miniTicker",
        "tracusdt@miniTicker",
        "keepusdt@miniTicker",
        "monausdt@miniTicker",
        "titanusdt@miniTicker",
        "dntusdt@miniTicker",
        "repusdt@miniTicker",
        "linausdt@miniTicker",
        "scrtusdt@miniTicker",
        "vrausdt@miniTicker",
        "twtusdt@miniTicker",
        "roseusdt@miniTicker",
        "sysusdt@miniTicker",
        "utkusdt@miniTicker",
        "rifusdt@miniTicker",
        "susdusdt@miniTicker",
        "hiveusdt@miniTicker",
        "runeusdt@miniTicker",
        "lendusdt@miniTicker",
        "ersdlusdt@miniTicker",
        "vaiusdt@miniTicker",
        "cotiusdt@miniTicker",
        "qkcusdt@miniTicker",
        "gasusdt@miniTicker",
        "superusdt@miniTicker",
        "nwcusdt@miniTicker",
        "hnsusdt@miniTicker",
        "atriusdt@miniTicker",
        "bunnyusdt@miniTicker"
    ];
}; 